var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitcoincolor1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M301.009,508.052c105.084-18.639,188.013-101.383,206.924-206.374L368.657,162.402l-89.671,76.933 L155.374,362.417L301.009,508.052z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD15D"
    },
    cx: 256,
    cy: 256,
    r: 127.569
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M383.569,256c0-70.358-56.96-127.405-127.281-127.562v255.124 C326.609,383.405,383.569,326.358,383.569,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M256,402.532c-80.798,0-146.532-65.734-146.532-146.532S175.202,109.468,256,109.468 S402.532,175.202,402.532,256S336.798,402.532,256,402.532z M256,147.394c-59.885,0-108.606,48.721-108.606,108.606 S196.115,364.606,256,364.606S364.606,315.885,364.606,256S315.885,147.394,256,147.394z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A200"
    },
    d: "M402.532,256c0-80.701-65.579-146.368-146.244-146.525v37.926 C316.04,147.558,364.606,196.211,364.606,256S316.04,364.442,256.288,364.599v37.926C336.953,402.368,402.532,336.701,402.532,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E3C3"
    },
    d: "M302.413,256c7.997-7.009,13.062-17.287,13.062-28.732c0-18.816-13.674-34.487-31.604-37.628v-7.383 c0-5.236-4.246-9.481-9.481-9.481s-9.481,4.246-9.481,9.481v6.799H245.56v-6.799c0-5.236-4.246-9.481-9.481-9.481 s-9.481,4.246-9.481,9.481v6.799h-6.799c-5.236,0-9.481,4.246-9.481,9.481v114.926c0,5.236,4.246,9.481,9.481,9.481h6.799v6.799 c0,5.236,4.246,9.481,9.481,9.481s9.481-4.246,9.481-9.481v-6.799h19.347v6.799c0,5.236,4.246,9.481,9.481,9.481 s9.481-4.246,9.481-9.481v-7.384c17.93-3.141,31.604-18.811,31.604-37.628C315.475,273.287,310.41,263.009,302.413,256z  M296.512,227.268c0,10.614-8.637,19.251-19.251,19.251h-47.981v-38.5h47.981C287.875,208.019,296.512,216.654,296.512,227.268z  M277.261,303.981h-47.981v-38.5h47.981c10.614,0,19.251,8.637,19.251,19.251C296.512,295.346,287.875,303.981,277.261,303.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED8B2"
    },
    d: "M302.413,256c7.997-7.009,13.062-17.287,13.062-28.732c0-18.816-13.674-34.487-31.604-37.628v-7.383 c0-5.236-4.246-9.481-9.481-9.481s-9.481,4.246-9.481,9.481v6.799h-8.62v18.963h20.973c10.614,0,19.251,8.635,19.251,19.249 c0,10.614-8.637,19.251-19.251,19.251h-20.973v18.963h20.973c10.614,0,19.251,8.637,19.251,19.251 c0,10.614-8.637,19.249-19.251,19.249h-20.973v18.963h8.62v6.799c0,5.236,4.246,9.481,9.481,9.481s9.481-4.246,9.481-9.481v-7.384 c17.93-3.141,31.604-18.811,31.604-37.628C315.475,273.287,310.41,263.009,302.413,256z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoincolor1);
export default __webpack_public_path__ + "static/media/bitcoincolor1.e31761d94d5a89dd1d7dc370074eee98.svg";
export { ForwardRef as ReactComponent };